import { Segmented } from "antd";
import React, { useState } from "react";
import PreparationLandingPage from "./preparation/PreparationLandingPage";

function PrepGuidesMain() {
  const [selectedTab, setSelectedTab] = useState("Your Guides");
  return (
    <div className="py-[1.1rem] px-[0.8rem] lg:px-6">
      {selectedTab === "Your Guides" && (
        <PreparationLandingPage setSelectedTab={setSelectedTab} />
      )}
    </div>
  );
}

export default PrepGuidesMain;
